import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotificationService } from '@progress/kendo-angular-notification';
import { takeUntil } from 'rxjs';
import { DocumentService } from 'src/app/services/document.service';
import { EITransitionService } from 'src/app/services/ei-transition.service';
import {
  dialogAnimationDuration,
  dialogTimer,
} from '../../constants/dialog-specs';
import { NOTIFICATION_MESSAGES } from '../../constants/notification-messages';
import { AbstractComponent } from '../abstract-component';

@Component({
  selector: 'app-request-reupload',
  templateUrl: './request-reupload.component.html',
  styleUrls: ['./request-reupload.component.scss'],
  standalone: false,
})
export class RequestReuploadComponent extends AbstractComponent {
  // TODO: Right now we are not changing name of this dialog as we need to change in the entire application
  @Output() closeDialog: EventEmitter<void> = new EventEmitter<void>();
  @Input() lfEntryId: number;
  @Input() studentSk: string;
  readonly eiStatusIdActionRequested: number = 3;
  readonly documentStatusIdDocumentResent: number = 2;
  form: FormGroup;

  constructor(
    private eiService: EITransitionService,
    private documentService: DocumentService,
    private notificationService: NotificationService,
    private fb: FormBuilder
  ) {
    super();

    this.form = this.fb.group({
      reason: ['', Validators.required],
    });
  }

  submit(): void {
    this.documentService
      .updateDocumentStatuses([
        {
          documentRef: this.lfEntryId,
          documentStatus: this.documentStatusIdDocumentResent,
          comment: this.form.get('reason').value,
        },
      ])
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((data: unknown) => {
        if (data) {
          this.eiService
            .requestNewDocument({
              studentSk: this.studentSk,
              eiStatus: this.eiStatusIdActionRequested,
            })
            .pipe(takeUntil(this.componentDestroyed))
            .subscribe((data: unknown) => {
              if (data) {
                this.notificationService.show({
                  content: NOTIFICATION_MESSAGES.submitSuccess,
                  cssClass: 'notification-success',
                  hideAfter: dialogTimer,
                  position: { horizontal: 'center', vertical: 'top' },
                  animation: {
                    type: 'slide',
                    duration: dialogAnimationDuration,
                  },
                  type: { style: 'success', icon: true },
                });
                this.closeDialog.emit();
              }
            });
        }
      });
  }

  onCancel(): void {
    this.closeDialog.emit();
  }

  public afterOnDestroy(): void {
    // afterOnDestroy
  }
}
